import { gql } from '@apollo/client';

const ORGANIZATION_AUTHENTICATION_SETTING_QUERY = gql`
  query organizationAuthenticationSetting {
    session: currentSession {
      organization {
        id
        settings {
          authentication
        }
      }
    }
  }
`;

export default ORGANIZATION_AUTHENTICATION_SETTING_QUERY;
